import { render, staticRenderFns } from "./ProjectTableContactMessageDoctor.vue?vue&type=template&id=0967dc0c&"
import script from "./ProjectTableContactMessageDoctor.vue?vue&type=script&lang=js&"
export * from "./ProjectTableContactMessageDoctor.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTableContactMessageDoctor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports